export function getMeetingPlatform(meetingLink: string | null): string {
  if (!meetingLink) return "Online"
  const url = meetingLink.toLowerCase()
  if (url.includes("zoom.us")) return "Zoom"
  if (url.includes("meet.google")) return "Google Meet"
  if (url.includes("teams.microsoft") || url.includes("teams.live")) return "Microsoft Teams"
  if (url.includes("webex.com")) return "Webex"
  return "Online"
}
